<template>
  <div class="item">
    <i :class="['icon', 'icon--' + props.icon]"></i>
    {{ props.title }}
  </div>
</template>

<script setup>
import { defineProps } from 'vue';
const props = defineProps({
  title: {
    type: String
  },
  icon: {
    type: String
  }
});
</script>
<style lang="scss" scoped>
.item {
  width: 380px;
  height: 200px;
  box-shadow: 0px 0px 32px 0 rgba(189, 235, 255, 0.7);
  margin: 0 30px;
  font-size: 32px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  user-select: none;
  padding: 0 20px;
}

@media screen and (max-width: 480px) {
  .item {
    margin: 0 20px;
  }
}

.icon {
  margin-right: 20px;
  width: 100px;
  height: 112px;
}

.icon--djxc {
  background: url('../../imgs/icons/dangjian@2x.png') no-repeat left center;
  background-size: contain;
}

.icon--hsjy {
  background: url('../../imgs/icons/hongse@2x.png') no-repeat left center;
  background-size: contain;
}

.icon--dxal {
  background: url('../../imgs/icons/dianxing@2x.png') no-repeat left center;
  background-size: contain;
}

.icon--fxyj {
  background: url('../../imgs/icons/fengxian@2x.png') no-repeat left center;
  background-size: contain;
}

.icon--flfg {
  background: url('../../imgs/icons/falv@2x.png') no-repeat left center;
  background-size: contain;
}

.icon--wmsw {
  background: url('../../imgs/icons/wenming@2x.png') no-repeat left center;
  background-size: contain;
}

.icon--xszj {
  background: url('../../imgs/icons/xiansuo@2x.png') no-repeat left center;
  background-size: contain;
}

.icon--bjqz {
  background: url('../../imgs/icons/baojing@2x.png') no-repeat left center;
  background-size: contain;
}

.icon--tsjb {
  background: url('../../imgs/icons/tousu@2x.png') no-repeat left center;
  background-size: contain;
}
</style>
